import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Supplier\DeleteSupplierController::deleteMethod
* @see app/Http/Controllers/Supplier/DeleteSupplierController.php
* @route '/api/supplier/supplier-delete/{supplier}'
*/
export const deleteMethod = (args: { supplier: string | number | { id: string | number } } | [supplier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/supplier/supplier-delete/{supplier}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Supplier\DeleteSupplierController::deleteMethod
* @see app/Http/Controllers/Supplier/DeleteSupplierController.php
* @route '/api/supplier/supplier-delete/{supplier}'
*/
deleteMethod.url = (args: { supplier: string | number | { id: string | number } } | [supplier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { supplier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { supplier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            supplier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        supplier: typeof args.supplier === 'object'
        ? args.supplier.id
        : args.supplier,
    }

    return deleteMethod.definition.url
            .replace('{supplier}', parsedArgs.supplier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Supplier\DeleteSupplierController::deleteMethod
* @see app/Http/Controllers/Supplier/DeleteSupplierController.php
* @route '/api/supplier/supplier-delete/{supplier}'
*/
deleteMethod.delete = (args: { supplier: string | number | { id: string | number } } | [supplier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Supplier\DeleteSupplierController::undo
* @see app/Http/Controllers/Supplier/DeleteSupplierController.php
* @route '/api/supplier/{id}/undo-delete'
*/
export const undo = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/supplier/{id}/undo-delete',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Supplier\DeleteSupplierController::undo
* @see app/Http/Controllers/Supplier/DeleteSupplierController.php
* @route '/api/supplier/{id}/undo-delete'
*/
undo.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return undo.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Supplier\DeleteSupplierController::undo
* @see app/Http/Controllers/Supplier/DeleteSupplierController.php
* @route '/api/supplier/{id}/undo-delete'
*/
undo.get = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Supplier\DeleteSupplierController::undo
* @see app/Http/Controllers/Supplier/DeleteSupplierController.php
* @route '/api/supplier/{id}/undo-delete'
*/
undo.head = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteSupplierController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteSupplierController